<template>
  <div class="node-body">
    <div class="node-contetent">
      <div class="node-line"
      v-for="item of nodeData"
      :key="item.id"
      >
        <div class="node-title">
          <span
          @click.stop="commit(item.id)"
          :class="item.id === id ? 'active' : ''"
          v-html="setTile(item.title.replace(/\s/g, ''))"
          >
          </span>
          <img src="./arrow-down.png" v-if="levels[item.id]  && item.children && item.children.length" @click.stop="check(item)">
          <template v-else>
            <img src="./arrow-right.png" v-if="item.children && item.children.length" @click.stop="check(item)">
          </template>
        </div>
        <template v-if="levels[item.id]">
          <tree-node :nodeData="item.children" @jump="commit"></tree-node>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tree-node',
  props: {
    nodeData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      id: '',
      levels: {}
    }
  },
  methods: {
    check (item) {
      if (this.levels[item.id]) {
        this.$set(this.levels, item.id, undefined)
      } else {
        this.$set(this.levels, item.id, item)
      }
    },
    setTile (title) {
      if (title.indexOf('编') !== -1) {
        return title.replace('编', '编&nbsp;&nbsp;&nbsp;&nbsp;')
      }
      if (title.indexOf('章') !== -1) {
        return title.replace('章', '章&nbsp;&nbsp;&nbsp;&nbsp;')
      }
      if (title.indexOf('条') !== -1) {
        return title.replace('条', '条&nbsp;&nbsp;&nbsp;&nbsp;')
      }
      if (title.indexOf('节') !== -1) {
        return title.replace('节', '节&nbsp;&nbsp;&nbsp;&nbsp;')
      }
      return title
    },
    commit (id) {
      this.id = id
      this.$emit('jump', id)
    }
  }
}
</script>
<style lang="stylus" scoped>
.node-body
  text-align: left
  .node-line
    padding-left 0.24rem
    .node-title
      display flex
      justify-content: space-between
      align-items center
      width: 100%
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      border-bottom 1px solid #e5e5e5
      padding 0.2rem 0
      span
        font-size 0.2rem
        width: 100%
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
      .active
        color #007bff
      img
        flex-shrink 0
        width 0.3rem
        height 0.3rem
</style>
